export const DEFAULT_LABEL_HEIGHT = 32
